/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState, useCallback } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";
import getCroppedImg from "../../utils/cropImage";
import { CropperWrapper } from "../../utils/CropperWrapper";
import ImageUploader from "../../utils/ImageUploader";

// CD02 — KD46500/600 WHITE BABY 330x333
// Pozycje tekstów (style inline, w mm):
//   top   = górna krawędź pola tekstowego
//   left  = środek tekstu (textAlign center + translateX(-50%)) albo lewa krawędź (textAlign left)
//   right = prawa krawędź pola (textAlign right)
// maxWidthN = maks. szerokość tekstu w px — dłuższy tekst zmniejsza czcionkę.
// Uwaga: lineHeight w stylu InlineEdit nie działa (nadpisuje go `font: inherit`), zawsze wynosi 1.5.
export const Cd02: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("czwartek");
  const [text2, setText2] = useState<string>("7");
  const [text3, setText3] = useState<string>("00:26");
  const [text4, setText4] = useState<string>("stycznia 2021");
  const [text5, setText5] = useState<string>("Nowa Sól");
  const [text6, setText6] = useState<string>("OSKAR");
  const [text7, setText7] = useState<string>("55");
  const [text8, setText8] = useState<string>("3600");
  const [text9, setText9] = useState<string>("g");
  const [text10, setText10] = useState<string>("cm");
  const text1BasicSize = 22;
  const text2BasicSize = 107;
  const text3BasicSize = 60;
  const text4BasicSize = 20;
  const text5BasicSize = 20;
  const text6BasicSize = 112;
  const text7BasicSize = 69;
  const text8BasicSize = 62;
  const text9BasicSize = 47;
  const text10BasicSize = 41;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const [fontSizeText7, setFontSizeText7] = useState<number>(text7BasicSize);
  const [fontSizeText8, setFontSizeText8] = useState<number>(text8BasicSize);
  const [fontSizeText9, setFontSizeText9] = useState<number>(text9BasicSize);
  const [fontSizeText10, setFontSizeText10] = useState<number>(text10BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();
  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");

  const pdfWidth = "330mm"; // PDF width in mm
  const pdfHeight = "333mm"; // PDF height in mm
  const font1 = "JustSayin";
  const font2 = "MaritimeTropicalNeue";
  const maxWidth1 = 173;
  const maxWidth2 = 125;
  const maxWidth3 = 216;
  const maxWidth4 = 196;
  const maxWidth5 = 155;
  const maxWidth6 = 454;
  const maxWidth7 = 152;
  const maxWidth8 = 151;
  const maxWidth9 = 43;
  const maxWidth10 = 129;
  // Okno na zdjęcie użytkownika
  const photoTop = "23.6mm";
  const photoLeft = "75.1mm";
  const photoWidth = "182.7mm";
  const photoHeight = "175.6mm";
  const photoAspect = 182.7 / 175.6;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
    fontFamily: string,
    maxWidth: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px ${fontFamily}`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  // Czekamy na załadowanie fontu, inaczej canvas mierzy tekst fontem zastępczym.
  const ensureFont = (fontFamily: string) => document.fonts.load(`1em ${fontFamily}`);

  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 10, font1, maxWidth1))
    );
  }, [text1]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 14, font1, maxWidth2))
    );
  }, [text2]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 14, font1, maxWidth3))
    );
  }, [text3]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText4(adjustFontSize(text4, fontSizeText4, text4BasicSize, 10, font1, maxWidth4))
    );
  }, [text4]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText5(adjustFontSize(text5, fontSizeText5, text5BasicSize, 10, font1, maxWidth5))
    );
  }, [text5]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText6(adjustFontSize(text6, fontSizeText6, text6BasicSize, 14, font2, maxWidth6))
    );
  }, [text6]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText7(adjustFontSize(text7, fontSizeText7, text7BasicSize, 14, font1, maxWidth7))
    );
  }, [text7]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText8(adjustFontSize(text8, fontSizeText8, text8BasicSize, 14, font1, maxWidth8))
    );
  }, [text8]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText9(adjustFontSize(text9, fontSizeText9, text9BasicSize, 14, font1, maxWidth9))
    );
  }, [text9]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText10(adjustFontSize(text10, fontSizeText10, text10BasicSize, 14, font1, maxWidth10))
    );
  }, [text10]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      true
    );
  };

  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage = useCallback(async () => {
    if (image && croppedAreaPixels) {
      const croppedImg = await getCroppedImg(image, croppedAreaPixels);
      setCroppedImage(croppedImg);
      setStep("view");
    }
  }, [image, croppedAreaPixels]);

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
        <ImageUploader
          onImageChange={(image) => setImage(image)}
          setStep={setStep}
        />
        {step === "crop" && (
          <p>
            Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
          </p>
        )}
        <div style={{}}>
          {step !== "crop" && (
            <Button onClick={handleSave} disabled={isSaving}>
              {isSaving ? "Zapisywanie..." : "Zapisz"}
            </Button>
          )}
          {step === "crop" && (
            <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
          )}
        </div>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "JustSayin, MaritimeTropicalNeue",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        {/* czwartek */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: font1,
            color: "#2b2a29",
            position: "absolute",
            top: "182.3mm",
            left: "56.5mm",
            width: `${maxWidth1 + 10}px`,
            transform: "translateX(-50%) rotate(-5.2deg)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 7 */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: font1,
            color: "#2b2a29",
            position: "absolute",
            top: "179mm",
            left: "57.7mm",
            width: `${maxWidth2 + 10}px`,
            transform: "translateX(-50%) rotate(-4.9deg)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 00:26 */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: font1,
            color: "#2b2a29",
            position: "absolute",
            top: "196mm",
            left: "281.2mm",
            width: `${maxWidth3 + 10}px`,
            transform: "translateX(-50%) rotate(3.3deg)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "0.5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* stycznia 2021 */}
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: font1,
            color: "#2b2a29",
            position: "absolute",
            top: "213.5mm",
            left: "59.8mm",
            width: `${maxWidth4 + 10}px`,
            transform: "translateX(-50%) rotate(-5.2deg)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "-0.16px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* Nowa Sól */}
        <InlineEdit
          value={text5}
          setValue={setText5}
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: font1,
            color: "#2b2a29",
            position: "absolute",
            top: "220.1mm",
            left: "60.6mm",
            width: `${maxWidth5 + 10}px`,
            transform: "translateX(-50%) rotate(-5.2deg)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* OSKAR */}
        <InlineEdit
          value={text6}
          setValue={setText6}
          style={{
            fontSize: `${fontSizeText6}px`,
            fontFamily: font2,
            color: "#2b2a29",
            position: "absolute",
            top: "204.8mm",
            left: "166mm",
            width: `${maxWidth6 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "5.68px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 55 */}
        <InlineEdit
          value={text7}
          setValue={setText7}
          style={{
            fontSize: `${fontSizeText7}px`,
            fontFamily: font1,
            color: "#2b2a29",
            position: "absolute",
            top: "258.1mm",
            left: "137mm",
            width: `${maxWidth7 + 10}px`,
            transform: "translateX(-50%) rotate(-1.6deg)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 3600 */}
        <InlineEdit
          value={text8}
          setValue={setText8}
          style={{
            fontSize: `${fontSizeText8}px`,
            fontFamily: font1,
            color: "#2b2a29",
            position: "absolute",
            top: "259.6mm",
            left: "199.8mm",
            width: `${maxWidth8 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* g */}
        <InlineEdit
          value={text9}
          setValue={setText9}
          style={{
            fontSize: `${fontSizeText9}px`,
            fontFamily: font1,
            color: "#2b2a29",
            position: "absolute",
            top: "265.1mm",
            left: "225.3mm",
            width: `${maxWidth9 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* cm */}
        <InlineEdit
          value={text10}
          setValue={setText10}
          style={{
            fontSize: `${fontSizeText10}px`,
            fontFamily: font1,
            color: "#2b2a29",
            position: "absolute",
            top: "282mm",
            left: "135.3mm",
            width: `${maxWidth10 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "1.9px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />

        {/* Step: Crop */}
        {image && step === "crop" && (
          <CropperWrapper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={photoAspect}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
            style={{
              top: photoTop,
              left: photoLeft,
              width: photoWidth,
              height: photoHeight,
              transform: "none",
            }}
          />
        )}

        {/* Step: View */}
        {croppedImage && step === "view" && (
          <img
            src={croppedImage}
            alt=""
            style={{
              position: "absolute",
              top: photoTop,
              left: photoLeft,
              width: photoWidth,
              height: photoHeight,
              objectFit: "cover",
              clipPath: "polygon(99.91% 49.76%, 99.79% 53.41%, 99.41% 57.05%, 98.81% 60.65%, 98.17% 64.26%, 97.49% 67.91%, 96.75% 71.63%, 95.80% 75.35%, 94.67% 79.10%, 93.12% 82.70%, 90.76% 85.75%, 87.78% 88.17%, 84.63% 90.31%, 81.53% 92.35%, 78.32% 94.14%, 75.03% 95.68%, 71.67% 96.96%, 68.31% 98.08%, 64.89% 98.89%, 61.46% 99.50%, 58.02% 99.79%, 54.62% 100.00%, 51.22% 99.85%, 47.87% 99.57%, 44.57% 98.98%, 41.34% 98.17%, 38.18% 97.17%, 35.10% 96.02%, 32.09% 94.70%, 29.15% 93.27%, 26.28% 91.68%, 23.49% 89.94%, 20.86% 87.95%, 18.30% 85.86%, 15.88% 83.58%, 13.52% 81.21%, 11.32% 78.65%, 9.06% 76.08%, 7.01% 73.29%, 5.13% 70.33%, 3.50% 67.19%, 2.18% 63.89%, 1.14% 60.46%, 0.43% 56.94%, 0.07% 53.35%, 0.00% 49.76%, 0.12% 46.16%, 0.48% 42.58%, 1.03% 39.02%, 1.81% 35.51%, 2.73% 32.03%, 3.83% 28.58%, 5.17% 25.21%, 6.70% 21.90%, 8.40% 18.65%, 10.46% 15.63%, 12.88% 12.92%, 15.66% 10.60%, 18.57% 8.50%, 21.60% 6.64%, 24.80% 5.16%, 28.02% 3.83%, 31.29% 2.75%, 34.59% 1.87%, 37.92% 1.23%, 41.23% 0.67%, 44.54% 0.30%, 47.87% 0.06%, 51.21% 0.00%, 54.55% 0.19%, 57.89% 0.50%, 61.24% 0.95%, 64.60% 1.54%, 67.98% 2.28%, 71.38% 3.17%, 74.81% 4.23%, 78.16% 5.60%, 81.39% 7.34%, 84.45% 9.42%, 87.50% 11.61%, 90.47% 14.02%, 93.08% 16.84%, 95.36% 19.96%, 97.10% 23.44%, 98.30% 27.16%, 99.14% 30.98%, 99.64% 34.81%, 99.88% 38.62%, 99.96% 42.38%, 100.00% 46.08%)",
              zIndex: 1,
            }}
          />
        )}

        <img
          src="/images/CD02.svg"
          alt=""
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '2' }}
        />
      </div>
    </div>
  );
};
